import { ParameterValidator,decodeEntities } from '@mvps-genesis/utilities';
import Glide from '@glidejs/glide';

export default class Carousel {
	
	// default/fallback slider parameters
	defaultParameters = {
		perView: 4,
		gap: 16,
		breakpoints: {
			768: {
				perView: 2,
				peek: {
					before: 0,
					after: 50
				}
			}
		}
	};

	constructor( container, parameters ) {

		// validator
		this._validator = new ParameterValidator( this );

		// glide elements to validate
		this.container = this._validator.isElement( 'container', container );
		this.track = this._validator.isElement( 'carousel track container', '.x-carousel__track', {container: this.container} );
		this.slides = this._validator.isElement( 'carousel slides container', '.x-carousel__slides', {container: this.container} );

		// optional glide elements
		this.arrows = this._validator.isElement( 'carousel arrows container', '.x-carousel__arrows', {required: false, container: this.container} );
		this.bullets = this._validator.isElement( 'carousel bullets container', '.x-carousel__bullets', {required: false, container: this.container} );

		// carousel parameters set (via JS code) vs dataset (via template code). dataset value will take priority 
		parameters = ( this.container.dataset.options.length ) ? JSON.parse( decodeEntities( this.container.dataset.options ) ) : parameters;

		// use default parameters if nothing is passed
		this.parameters = ( parameters ) ? parameters : this.defaultParameters;

		// attach classes and carousel specific attributes (Glide.js)
		this.build();

		// initialize slider
		this.init();

	}

	build() {

		this.container.classList.add('glide');

		if ( this.track ) {
			this.track.classList.add('glide__track');
			this.track.dataset.glideEl = 'track';
		}
		
		if ( this.slides ) {
			this.slides.classList.add('glide__slides');

			this.slideElements = this.slides.getElementsByClassName('x-carousel__slide');
			this.slideCount = this.slideElements.length;

			for (let slideElement of this.slideElements) {
				slideElement.classList.add('glide__slide');
			}
		}
		
		if ( this.arrows ) {
		
			this.arrows.classList.add('glide__arrows');
			this.arrows.dataset.glideEl = 'controls';

			const arrowLeft = this.arrows.querySelector('.x-carousel__arrow--prev');
			const arrowRight = this.arrows.querySelector('.x-carousel__arrow--next');

			if ( arrowLeft ) {
				arrowLeft.classList.add('glide__arrow', 'glide__arrow--left');
				arrowLeft.dataset.glideDir = '|<';
			}

			if ( arrowRight ) {
				arrowRight.classList.add('glide__arrow', 'glide__arrow--right');
				arrowRight.dataset.glideDir = '|>';
			}

		}

		if ( this.bullets && ( this.slideCount > 0 ) ) {
			this.bullets.classList.add('glide__bullets');
			this.bullets.dataset.glideEl = 'controls[nav]';

			const bulletsLabel = this.bullets.dataset.componentLabel;

			let b = 0;

			while ( b < this.slideCount ) {
				const bulletButton = document.createElement('button');
				const bulletText = document.createElement('span');

				bulletButton.classList.add('glide__bullet');
				bulletButton.dataset.glideDir = '=' + b;

				if ( bulletsLabel.length ) {
					bulletText.classList.add('u-hide-visually');
					bulletText.textContent = bulletsLabel +  ' Slide ' + ( b + 1 );
					bulletButton.appendChild(bulletText);
				}
				
				this.bullets.appendChild(bulletButton);

				b++;
			}
		}
		
	}

	destroy() {

		if ( !this.container.classList.contains( 'glide--slider' ) && !this.container.classList.contains( 'glide--carousel' ) ) {
			return false;
		}

		if ( this.slider ) {
			this.slider.destroy();
		}

		return true;

	}

	init() {
		
		this.destroy();

		this.slider = new Glide( this.container, this.parameters ).mount();

	}
	
}
